import React from 'react'
import { useHistory } from 'react-router-dom'
import { useRequest } from '@sisyphe/hooks'
import * as api from 'services/store'
import { Controller, Pagination, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/less/pagination'
import './index.less'

export default function Index() {
  const history = useHistory()

  // 商城搜索框搜索-banner信息查询
  const { data } = useRequest(async () => {
    const { data } = await api.queryBannerUsingPOST_1({
      bannerName: '',
      enterpriseCode: '',
      pageNum: 0,
      pageSize: 10,
      productTypeCode: '',
      status: 1,
    })
    return data?.records || []
  })

  const openDetail = row => {
    if (row.bannerType === 'COOPERATIVE') {
      return
    }
    // 文创
    if (row?.contentType === 3) {
      history.push(`/detail/booart?spuCode=${row?.jumpSpuCode}`)
    }

    // 图书
    if ([1, 4].includes(row?.contentType!)) {
      history.push(`/detail/book?spuCode=${row?.jumpSpuCode}`)
    }
  }

  return data?.length ? (
    <Swiper
      loop
      modules={[Navigation, Pagination, Controller]}
      navigation={{
        prevEl: '.swiper-icon-prev',
        nextEl: '.swiper-icon-next',
      }}
      pagination={{ clickable: true }}
      scrollbar={{ draggable: true }}
    >
      {data?.map(item => (
        <SwiperSlide
          className="swiper-slide"
          key={item.bannerCode}
          onClick={() => openDetail(item)}
        >
          <img
            className={
              item.bannerType !== 'COOPERATIVE' ? 'swiper-slide-img' : ''
            }
            src={item.imgUrl}
            alt=""
          />
        </SwiperSlide>
      ))}
      {/* <!-- 如果需要导航按钮 --> */}
      <div className="swiper-icon swiper-icon-prev">
        <img src={require('./images/icon-prev.png')} alt="" />
      </div>
      <div className="swiper-icon swiper-icon-next">
        <img src={require('./images/icon-next.png')} alt="" />
      </div>
    </Swiper>
  ) : (
    <></>
  )
}
